"use client";

/**
 * Top-level `app/` segments outside the authenticated shell: they stay light
 * (BRE-8070). Read from the path, not an effect, so the server-rendered
 * bootstrap already paints a dark-mode user dark. `ThemeProvider.routes.BRE-8352.test.ts`
 * keeps this in step with the `app/` directory.
 */
export const LIGHT_ONLY_SEGMENTS: ReadonlySet<string> = new Set([
  "auth",
  "checkout",
  "design-system",
  "invitations",
  "invite",
  "join-request",
  "link-preview",
  "login",
  "logout",
  "next",
  "onboarding",
  "provisioning",
  "s",
  "signup"
]);

export function isThemedPath(pathname: string | null): boolean {
  return !LIGHT_ONLY_SEGMENTS.has(pathname?.split("/")[1] ?? "");
}
